export default __webpack_public_path__ + "static/media/household_resilience_mapping.ae92e1ad.svg";